import {
  Box,
  Button,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  Stack,
  Typography,
} from '@mui/material'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import RocketLaunchRoundedIcon from '@mui/icons-material/RocketLaunchRounded'
import { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import API from '../../../services/API'
import stepCatalogue from '../gettingStarted/stepCatalogue'
import { TenantSettingsContext, UserContext } from '../../../App'

const GettingStartedCard = () => {
  const { user } = useContext(UserContext)
  const { orgSettings } = useContext(TenantSettingsContext).orgConfig
  const [status, setStatus] = useState(null)
  const [dismissed, setDismissed] = useState(false)

  const isSiteAdmin = user?.security?.isSiteAdmin

  useEffect(() => {
    if (!isSiteAdmin || orgSettings?.onboardingComplete) return
    API.get('/onboarding/status', { skipGlobalErrorHandler: true })
      .then((res) => res.status === 200 && setStatus(res.data))
      .catch(() => {})
  }, [isSiteAdmin, orgSettings?.onboardingComplete])

  if (
    !isSiteAdmin ||
    orgSettings?.onboardingComplete ||
    !status ||
    status.completedAt ||
    status.dismissedAt ||
    dismissed
  ) {
    return null
  }

  const nextStep = status.steps.find((s) => !s.complete && !s.skipped)
  const nextCatalogue = nextStep && stepCatalogue[nextStep.key]

  const dismiss = () => {
    setDismissed(true)
    API.post('/onboarding/dismiss').catch(() => {})
  }

  return (
    <Grid item xs={12}>
      <Paper sx={{ p: 2 }}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ sm: 'center' }}
        gap={2}
      >
        <RocketLaunchRoundedIcon color="primary" sx={{ fontSize: 40 }} />
        <Box flex={1}>
          <Typography fontWeight={600}>
            Finish setting up your organisation
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {status.completedSteps} of {status.totalSteps} steps complete
            {nextCatalogue && <> — next up: {nextCatalogue.title}</>}
          </Typography>
          <LinearProgress
            variant="determinate"
            value={(status.completedSteps / status.totalSteps) * 100}
            sx={{ height: 6, borderRadius: 3, mt: 1 }}
          />
        </Box>
        <Stack direction="row" gap={1} alignItems="center" flexShrink={0}>
          <Button variant="contained" component={Link} to="/getting-started">
            Continue Setup
          </Button>
          <IconButton size="small" onClick={dismiss} title="Hide this card">
            <CloseRoundedIcon fontSize="small" />
          </IconButton>
        </Stack>
        </Stack>
      </Paper>
    </Grid>
  )
}

export default GettingStartedCard
